import { render, staticRenderFns } from "./StepJurisdictionAndTitle.vue?vue&type=template&id=487fce10&scoped=true&"
import script from "./StepJurisdictionAndTitle.vue?vue&type=script&lang=js&"
export * from "./StepJurisdictionAndTitle.vue?vue&type=script&lang=js&"
import style0 from "./StepJurisdictionAndTitle.vue?vue&type=style&index=0&id=487fce10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487fce10",
  null
  
)

export default component.exports